import React, { useEffect } from 'react';
import { Form, Modal, TreeSelect } from '@maxtropy/components';

export interface DeviceTreeNode {
  key: string;
  title?: string;
  value: string;
  children?: DeviceTreeNode[];
}

interface HighEnergyDeviceModalProps {
  open: boolean;
  value?: number[];
  treeData: DeviceTreeNode[];
  onCancel: () => void;
  onOk: (value: number[]) => void;
}

const HighEnergyDeviceModal: React.FC<HighEnergyDeviceModalProps> = ({ open, value, treeData, onCancel, onOk }) => {
  const [form] = Form.useForm<{ ids?: string[] }>();

  useEffect(() => {
    if (open) {
      form.setFieldsValue({ ids: value?.map(String) });
    }
  }, [form, open, value]);

  return (
    <Modal
      title="配置高能耗设备"
      open={open}
      onCancel={onCancel}
      onOk={() => {
        form.validateFields().then(values => onOk((values.ids ?? []).map(Number).filter(id => Number.isFinite(id))));
      }}
      afterClose={() => form.resetFields()}
    >
      <Form form={form}>
        <Form.Item label="高能耗设备" name="ids" rules={[{ required: true, message: '请选择高能耗设备' }]}>
          <TreeSelect
            allowClear
            maxTagCount={3}
            placeholder="请选择"
            treeDefaultExpandAll
            showSearch
            treeNodeFilterProp="title"
            treeCheckable
            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
            treeData={treeData}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default HighEnergyDeviceModal;
